// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__c4xI2","rightAdornment":"Header_rightAdornment__3SShn"};